import { useState } from "react";

export type FormStatus = "idle" | "submitting" | "success" | "error";

interface ParsedResponse {
  code?: string;
  message?: string;
  meta?: { message?: string; detail?: string };
}

export default function useFormSubmit() {
  const [status, setStatus] = useState<FormStatus>("idle");
  const [message, setMessage] = useState("");

  const reset = () => {
    setStatus("idle");
    setMessage("");
  };

  const submit = async (form: HTMLFormElement, honeypotName: string, successText: string) => {
    const payload = new FormData(form);
    const honeypotValue = String(payload.get(honeypotName) ?? "").trim();

    if (honeypotValue) {
      setStatus("success");
      setMessage(successText);
      form.reset();
      return;
    }

    payload.delete(honeypotName);
    const body = new URLSearchParams();
    payload.forEach((value, key) => {
      if (typeof value === "string") body.append(key, value);
    });

    setStatus("submitting");
    setMessage("");

    try {
      const response = await fetch(form.action, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: body.toString(),
      });

      const responseText = await response.text();
      let parsed: ParsedResponse | null = null;
      try {
        parsed = JSON.parse(responseText) as ParsedResponse;
      } catch {
        parsed = null;
      }

      const serverMsg =
        parsed?.meta?.message ||
        parsed?.message ||
        parsed?.meta?.detail ||
        responseText ||
        "";
      const lowered = String(serverMsg).toLowerCase();
      const isSpam = lowered.includes("spam");

      if (response.ok && parsed?.code === "OK" && !isSpam) {
        setStatus("success");
        setMessage(successText);
        form.reset();
      } else {
        setStatus("error");
        setMessage(isSpam ? "提交未通过校验，请检查填写内容后重试。" : serverMsg || "提交失败，请稍后重试。");
      }
    } catch {
      setStatus("error");
      setMessage("网络异常，提交失败，请稍后重试。");
    }
  };

  return { status, message, submit, reset };
}